export const getStatusColor = status => {
	switch(status.toLowerCase()) {
		case 'available': return {
			label: 'Available',
			color: 'apple'
		}
		case 'свободен': return {
			label: 'Свободен',
			color: 'apple'
		}
		case 'свободный': return {
			label: 'Свободный',
			color: 'apple'
		}
		case 'sold': return {
			label: 'Sold',
			color: 'monza'
		}
		case 'проданный': return {
			label: 'Проданный',
			color: 'monza'
		}
		case 'продаден': return {
			label: 'Продаден',
			color: 'monza'
		}
		case 'reserved': return {
			label: 'Reserved',
			color: 'buddha'
		}
		case 'зарезервированный': return {
			label: 'Зарезервированный',
			color: 'buddha'
		}
		case 'резервиран': return {
			label: 'Резервиран',
			color: 'buddha'
		}
		default: return {
			label: 'Свободен',
			color: 'apple'
		}
	}
}

export const getRoomAndType = (rooms, type, lang) => {
  if ( type === 'пентхаус' || type === 'penthouse' ) return type.charAt(0).toUpperCase() + type.substr(1)
	if( lang === 'bg' ) {
		switch (rooms) {
			case 2: return `Двустаен ${type}`
			case 3: return `Тристаен ${type}`
			case 4: return `Четиристаен ${type}`
			case 5:
			case 6: return `Многостаен ${type}`
			default: return type
		}
	}
	if( lang === 'en' ){
		switch (rooms) {
			case 2: return `2-room ${type}`
			case 3: return `3-room ${type}`
			case 4: return `4-room ${type}`
			case 5:
			case 6: return `Multiple room ${type}`
			default: return type
		}
	}
  if( lang === 'ru' ) {
    switch (rooms) {
      case 2: return `2-комнатный ${type}`
      case 3: return `3-комнатный ${type}`
      case 4: return `4-комнатный ${type}`
      case 5:
      case 6: return `Многокомнатный ${type}`
      default: return type
    }
  }
}

export const getRoomsText = (rooms, lang) => {
	if( lang === 'bg' ) {
		switch (rooms) {
			case 2: return `Двустаен`
			case 3: return `Тристаен`
			case 4: return `Четиристаен`
			case 5:
			case 6: return `Многостаен`
			default: return `${rooms} стаи`
		}
	}
	if ( lang === 'en' ) {
		switch (rooms) {
			case 2: return `2-room`
			case 3: return `3-room`
			case 4: return `4-room`
			case 5:
			case 6: return `Multiple room`
			default: return `${rooms} rooms`
		}
	}
  if( lang === 'ru' ) {
    switch (rooms) {
      case 2: return `2-комнатный`
      case 3: return `3-комнатный`
      case 4: return `4-комнатный`
      case 5:
      case 6: return `Многокомнатный`
      default: return `${rooms} комнаты`
    }
  }
}

export const getTypeFilterOptions = lang => {
	switch(lang) {
		case 'bg': return {
			'Двустаен апартамент': 'Двустаен апартамент',
			'Тристаен апартамент': 'Тристаен апартамент',
			'Четиристаен апартамент': 'Четиристаен апартамент',
			'Многостаен апартамент': 'Многостаен апартамент',
			'Многостаен мезонет': 'Многостаен мезонет',
			'Пентхаус': 'Пентхаус'
		}
		case 'en': return {
			'2-room apartment': '2-room apartment',
			'3-room apartment': '3-room apartment',
			'4-room apartment': '4-room apartment',
			'Multiple room apartment': 'Multiple room apartment',
			'Multiple room maisonette': 'Multiple room maisonette',
			'Penthouse': 'Penthouse'
  	}
    case 'ru': return {
      '2-комнатный апартамент': '2-комнатный апартамент',
      '3-комнатный апартамент': '3-комнатный апартамент',
      '4-комнатный апартамент': '4-комнатный апартамент',
      'Многокомнатный апартамент': 'Многокомнатный апартамент',
      'Многокомнатный мезонет': 'Многокомнатный мезонет',
      'Пентхаус': 'Пентхаус'
    }
		default: return {
			'Двустаен апартамент': 'Двустаен апартамент',
			'Тристаен апартамент': 'Тристаен апартамент',
			'Четиристаен апартамент': 'Четиристаен апартамент',
			'Многостаен апартамент': 'Многостаен апартамент',
			'Многостаен мезонет': 'Многостаен мезонет',
      'Пентхаус': 'Пентхаус'
		}
	}
}

export const getStatusFilterOptions = lang => {
	switch(lang) {
		case 'bg': return {
			'свободен': 'Свободен',
			'резервиран': 'Резервиран',
			'продаден': 'Продаден'
		}
		case 'en': return {
			'available': 'Available',
			'reserved': 'Reserved',
			'sold': 'Sold'
		}
    case 'ru': return {
      'свободный': 'Свободный',
      'зарезервированный': 'Зарезервированный',
      'проданный': 'Проданный'
    }
		default: return {
			'свободен': 'Свободен',
			'резервиран': 'Резервиран',
			'продаден': 'Продаден'
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/apartments.js